import { render } from "./DashboardEditor.vue?vue&type=template&id=32b78314&scoped=true"
import script from "./DashboardEditor.vue?vue&type=script&lang=js"
export * from "./DashboardEditor.vue?vue&type=script&lang=js"

import "./DashboardEditor.vue?vue&type=style&index=0&id=32b78314&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32b78314"]])

export default __exports__